import React, { useState } from "react"
import { Link } from "gatsby"

import { slugify } from "../utils/helpers"

import {
  TiendasList,
  RestaurantesList,
  ServiciosList,
} from "../data/categories"

const SideBarSection = ({ name, list, showToggle, toggle }) => (
  <div className="w-full mb-6">
    <div
      className="flex w-full justify-between"
      onClick={toggle}
      role="button"
      onKeyDown={toggle}
      tabIndex={0}
    >
      <span>{name}</span>
      <svg
        className="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="#666"
      >
        <path
          fillRule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </div>
    <div className={`text-gray-500 text-sm ${showToggle ? "" : "hidden"}`}>
      {list.map(t => {
        const slug = slugify(t)
        return (
          <Link
            to={`/categoria/${slug}`}
            key={t}
            className="flex justify-start items-start my-2"
          >
            <span>{t}</span>
          </Link>
        )
      })}
    </div>
  </div>
)

const SideBarSectionRegions = ({ name, list, showToggle, toggle }) => (
  <div className="w-full mb-6">
    <div
      className="flex w-full justify-between"
      onClick={toggle}
      role="button"
      onKeyDown={toggle}
      tabIndex={0}
    >
      <span>{name}</span>
      <svg
        className="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="#666"
      >
        <path
          fillRule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </div>
    <div className={`text-gray-500 text-sm ${showToggle ? "" : "hidden"}`}>
      {list.map(t => {
        const slug = slugify(t.fieldValue)
        return (
          <Link
            to={`/region/${slug}`}
            key={t.fieldValue}
            className="flex justify-start items-start my-2"
          >
            <span>{t.fieldValue}</span>
          </Link>
        )
      })}
    </div>
  </div>
)

const SideBar = ({ categories = [], regions = [], showSection = "" }) => {
  const [showTienda, setShowTienda] = useState(showSection === "tienda")
  const [showRestaurante, setShowRestaurante] = useState(
    showSection === "restaurante"
  )
  const [showRegions, setShowRegions] = useState(showSection === "region")
  // const [showServicio, setShowServicio] = useState(false)

  const toggleTienda = () => {
    setShowTienda(!showTienda)
  }
  const toggleRestaurante = () => {
    setShowRestaurante(!showRestaurante)
  }
  const toggleRegions = () => {
    setShowRegions(!showRegions)
  }
  // const toggleServicio = () => {
  //   setShowServicio(!showServicio)
  // }

  const tiendas = []
  const restaurantes = []
  const servicios = []

  categories.forEach(d => {
    if (TiendasList.includes(d.fieldValue)) {
      tiendas.push(d.fieldValue)
    }
    if (RestaurantesList.includes(d.fieldValue)) {
      restaurantes.push(d.fieldValue)
    }
    if (ServiciosList.includes(d.fieldValue)) {
      servicios.push(d.fieldValue)
    }
  })

  return (
    <div className="hidden md:block bg-white shadow-md rounded-lg p-6">
      <Link to="/" className="flex mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="#666"
          className="h-5 w-5 mr-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        <span>Todos</span>
      </Link>
      <SideBarSection
        name="Tiendas"
        list={tiendas}
        showToggle={showTienda}
        toggle={toggleTienda}
      />
      <SideBarSection
        name="Restaurantes"
        list={restaurantes}
        showToggle={showRestaurante}
        toggle={toggleRestaurante}
      />
      <Link
        to={`/categoria/servicio`}
        className="flex justify-start items-start my-2"
      >
        <span>Servicios</span>
      </Link>
      <SideBarSectionRegions
        name="Regiones"
        list={regions}
        showToggle={showRegions}
        toggle={toggleRegions}
      />
    </div>
  )
}

export default SideBar
